import React from 'react';

import type { ComoFuncionaSecao } from '../../components/como-funciona/ComoFunciona';

/**
 * Ajuda do Telão (at-130). Compartilhada entre a rota `/telao` e a aba "Telão" da Home, para
 * as duas explicarem a mesma coisa do mesmo jeito.
 */
export const SECOES_DE_AJUDA_DO_TELAO: ComoFuncionaSecao[] = [
  {
    titulo: 'As fases',
    conteudo: (
      <p>
        O telão mostra todos os veículos em atendimento agrupados em cinco fases do fluxo:{' '}
        <strong>Entrada e regulação</strong>, <strong>Desmontagem e carroceria</strong>,{' '}
        <strong>Pintura e acabamento</strong>, <strong>Mecânica e montagem</strong> e{' '}
        <strong>Finalização e entrega</strong>. Dentro de cada fase, as esteiras aparecem na ordem do cadastro, com o
        número de veículos ao lado — inclusive as que estão vazias, para a posição não mudar na TV. Uma esteira criada
        depois, que ainda não pertence a fase nenhuma, aparece em <strong>Outras esteiras</strong> quando tiver
        veículo.
      </p>
    ),
  },
  {
    titulo: 'O que cada placa mostra',
    conteudo: (
      <p>
        A faixa colorida é a <strong>classe</strong> do veículo (as mesmas cores do resto do sistema) e traz os dias
        na oficina. Abaixo vêm a placa, o modelo e a cor, e a <strong>trilha</strong> das etapas de serviço planejadas:
        verde é etapa feita, roxo é serviço que começou e ficou inacabado, amarelo é a etapa atual, turquesa
        tracejado é um serviço acontecendo em paralelo e vermelho é o que ainda está previsto. As etapas de controle
        (Aguardando, Orçamento, Sindicância e as demais de fluxo livre) não entram na trilha.
      </p>
    ),
  },
  {
    titulo: 'Selos de parado e de liberação',
    conteudo: (
      <p>
        <strong>N d parado</strong> em amarelo marca o veículo que não muda de esteira há mais de 48 horas — a mesma
        regra do cartão <strong>Veículos parados</strong> da Home; em vermelho, há mais de 5 dias. Quando o veículo não
        está parado, o selo mostra a liberação administrativa: <strong>Liberado</strong> (total) ou{' '}
        <strong>Liberação parcial</strong>. O contador <strong>liberados pela administração</strong> conta só a
        liberação total.
      </p>
    ),
  },
  {
    titulo: 'A troca de página',
    conteudo: (
      <p>
        Como nem todas as placas cabem de uma vez, cada fase é cortada em páginas pelo que cabe na tela, e todas
        trocam juntas, sem deslizar, a cada 12 segundos (ajuste em <strong>Troca a cada</strong>). Clicar num dos traços do topo leva direto àquela página. A fase que cabe
        inteira fica parada e diz isso. <strong>Pausar</strong> congela a página atual; com um veículo aberto, a troca
        também espera.
      </p>
    ),
  },
  {
    titulo: 'Tela cheia e atualização',
    conteudo: (
      <p>
        <strong>Abrir em tela cheia</strong> leva ao telão sem o menu, para deixar na TV. Lá ele
        recarrega os dados a cada minuto (além de se atualizar sozinho quando um veículo muda de esteira). O telão
        segue o tema que você escolheu no menu lateral (claro, escuro ou o do sistema). Clicar
        numa placa abre as informações do atendimento, só para consulta; em tela cheia elas fecham sozinhas depois de
        30 segundos para o quadro voltar.
      </p>
    ),
  },
];
